import React, { createContext, useContext, useState } from "react";
import { getUtmParams } from "./whatsappConfig";

// Initialize the context
const AppContext = createContext();

// Create a custom hook to use the context
export const useAppContext = () => useContext(AppContext);

// Provider component
export const AppProvider = ({ children }) => {
  const [toSend, setToSend] = useState({
    name: "",
    email: "",
    phone: "",
    comments: "",
    medio: "",
    horario: "",
    // Assuming vMarca and vehiculoSeleccionado are passed somehow or managed within the context
    vehicle: "",
    origen: "",
  });

  // Method to update vehicle and origen based on external variables
  const updateToSend = (vMarca, vehiculoSeleccionado, utm_source, utm_medium) => {
    const u = getUtmParams();
    setToSend((prev) => ({
      ...prev,
      vehicle: `${vMarca ? vMarca : ""} ${vehiculoSeleccionado}`,
      origen: `${utm_source != null && utm_source !== "" ? utm_source : u.utm_source} ${
        utm_medium != null && utm_medium !== "" ? utm_medium : u.utm_medium
      }`,
    }));
  };

  return <AppContext.Provider value={{ toSend, setToSend, updateToSend }}>{children}</AppContext.Provider>;
};
